import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { updateGridSettings } from 'actions/auth/updateGridSettings';

export const GET_WORKFLOW_QUEUE_REQUEST = 'GET_WORKFLOW_QUEUE_REQUEST';
export const GET_WORKFLOW_INITIAL_QUEUE_SUCCESS = 'GET_WORKFLOW_INITIAL_QUEUE_SUCCESS';
export const GET_WORKFLOW_SECONDARY_QUEUE_SUCCESS = 'GET_WORKFLOW_SECONDARY_QUEUE_SUCCESS';
export const GET_WORKFLOW_EXPERT_QUEUE_SUCCESS = 'GET_WORKFLOW_EXPERT_QUEUE_SUCCESS';
export const GET_WORKFLOW_COMPLETE_QUEUE_SUCCESS = 'GET_WORKFLOW_COMPLETE_QUEUE_SUCCESS';
export const GET_WORKFLOW_QUEUE_FAILURE = 'GET_WORKFLOW_QUEUE_FAILURE';

function request() {
  return {
    type: GET_WORKFLOW_QUEUE_REQUEST,
  };
}

function receive(stage, data) {
  switch (stage) {
    case 'pendingreview':
      return {
        type: GET_WORKFLOW_INITIAL_QUEUE_SUCCESS,
        initialReviewQueue: data
      };
    case 'pendingsecondaryreview':
      return {
        type: GET_WORKFLOW_SECONDARY_QUEUE_SUCCESS,
        secondaryReviewQueue: data
      };
    case 'pendingexpertreview':
      return {
        type: GET_WORKFLOW_EXPERT_QUEUE_SUCCESS,
        expertReviewQueue: data
      };
    case 'complete':
      return {
        type: GET_WORKFLOW_COMPLETE_QUEUE_SUCCESS,
        completeQueue: data
      };
    default:
      return null;
  }
}

function reject(error) {
  return {
    type: GET_WORKFLOW_QUEUE_FAILURE,
  };
}

export function getWorkflowQueue(workflow, pageNumber, pageSize, totalLimit, stage, searchQuery, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected, formTypes, sortByField, sortDirection, filterList) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getWorkflowQueue(workflow, pageNumber, pageSize, totalLimit, stage, searchQuery, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected, formTypes, sortByField, sortDirection, filterList)
      .then((response) => {
        dispatch(updateGridSettings(response.data.myWork.totalLimit));
        dispatch(receive(stage, response.data.queues[0]));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}

export function getWorkflowQueueByObject(requestObject) {
  return (dispatch) => {
    dispatch(request());

    return ApiService
      .getWorkflowQueue(
        requestObject.workflow,
        requestObject.pageNumber,
        requestObject.pageSize,
        requestObject.totalLimit,
        requestObject.stage,
        requestObject.searchQuery,
        requestObject.legalEntity,
        requestObject.legalEntitySelected,
        requestObject.accountNumber,
        requestObject.accountNumberSelected,
        requestObject.customer,
        requestObject.customerSelected,
        requestObject.formTypes,
        requestObject.sortByField,
        requestObject.sortDirection,
        requestObject.filterList
      )
      .then((response) => {
        dispatch(updateGridSettings(response.data.queues[0].totalLimit));
        dispatch(receive(requestObject.stage, response.data.queues[0]));
      }).catch((error) => {
        dispatch(handleException(error, reject, true));
      });
  };
}
